import React, { useState } from "react";
import Screen from "../../components/layout/Screen";
import { Box } from "@mui/material";
import { DUMMY_MERMAID_CHART_EXAMPLES } from "../../components/mermaid/data/DUMMY_MERMAID_CHART_EXAMPLES";
import MermaidChartSelector from "../../components/mermaid/components/MermaidChartSelector";
import MermaidChart from "../../components/mermaid/components/MermaidChart";
import MermaidChartViewer from "../../components/mermaid/components/MermaidChartViewer";

const MermaidChartRoute = ({ children }) => {
  const [selectedChart, setSelectedChart] = useState("flowchart");
  const [charts, setCharts] = useState(DUMMY_MERMAID_CHART_EXAMPLES);

  const handleChartChange = (newDiagram) => {
    setCharts((prev) => ({
      ...prev,
      [selectedChart]: {
        ...prev[selectedChart],
        diagram: newDiagram,
      },
    }));
  };
  return (
    <Screen
      sx={{
        height: "100%",
        // background: "red",
        display: "flex",
        flexDirection: "column",
        //
      }}
    >
      <Box sx={{ p: 1, flexGrow: 0, borderBottom: "1px solid #ccc" }}>
        <MermaidChartSelector
          selectedChart={selectedChart}
          setSelectedChart={setSelectedChart}
        />
      </Box>
      <MermaidChartViewer
        title={charts[selectedChart].title}
        chart={charts[selectedChart].diagram}
      />
      {/* <Box
        sx={{
          background: "blue",
          flexGrow: 1,
          overflow: "hidden",
          display: "flex",
        }}
      >
        <Box sx={{ background: "green", flexGrow: 1 }}>sidebar</Box>
        <Box sx={{ background: "yellow", flexGrow: 1 }}>
          {" "}
          <MermaidChart
            chart={charts[selectedChart].diagram}
            title={charts[selectedChart].title}
            onChartChange={handleChartChange}
          />{" "}
        </Box>
      </Box> */}
      {children}
    </Screen>
  );
};

export default MermaidChartRoute;
